import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { AppLayoutComponent } from './layout/app.layout.component';
import { authGuard } from './core/guards/auth/auth.guard';
import { RoleGuard } from '@core/guards';
import { RolModuleEnum } from '@core/enums';

const routerOptions: ExtraOptions = {
  anchorScrolling: 'enabled',
  onSameUrlNavigation: 'reload',
  useHash: false,
};
const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        data: {
          breadcrumb: 'Account',
          roles: [RolModuleEnum.Account],
        },
        canActivate: [RoleGuard],
        loadChildren: () =>
          import('./views/modules/account/account.module').then(
            (m) => m.AccountModule,
          ),
      },
      {
        path: 'account',
        data: {
          breadcrumb: 'Account',
          roles: [RolModuleEnum.Account],
        },
        canActivate: [RoleGuard],
        loadChildren: () =>
          import('./views/modules/account/account.module').then(
            (m) => m.AccountModule,
          ),
      },
      {
        path: 'reseller',
        data: { breadcrumb: 'Resellers', roles: [RolModuleEnum.Reseller] },
        canActivate: [RoleGuard],
        loadChildren: () =>
          import('./views/modules/reseller/reseller.module').then(
            (m) => m.ResellerModule,
          ),
      },
      {
        path: 'store',
        data: {
          breadcrumb: 'Store',
          roles: [RolModuleEnum.Store],
        },
        canActivate: [RoleGuard],
        loadChildren: () =>
          import('./views/modules/store/store.module').then(
            (m) => m.StoreModule,
          ),
      },
      {
        path: 'role',
        data: {
          breadcrumb: 'Role',
          roles: [RolModuleEnum.Role],
        },
        canActivate: [RoleGuard],
        loadChildren: () =>
          import('./views/modules/role/role.module').then((m) => m.RoleModule),
      },
      {
        path: 'user',
        data: {
          breadcrumb: 'User',
          roles: [RolModuleEnum.User],
        },
        canActivate: [RoleGuard],
        loadChildren: () =>
          import('./views/modules/user/user.module').then((m) => m.UserModule),
      },
      {
        path: 'apk',
        data: { breadcrumb: 'Apk', roles: [RolModuleEnum.Apk] },
        canActivate: [RoleGuard],
        loadChildren: () =>
          import('./views/modules/apk/apk.module').then((m) => m.ApkModule),
      },
    ],
  },
  {
    path: 'login',
    data: { breadcrumb: 'Login' },
    loadChildren: () =>
      import('./views/pages/auth/login/login.module').then(
        (m) => m.LoginModule,
      ),
  },
  { path: 'auth', data: { breadcrumb: 'Auth' }, loadChildren: () => import('./views/pages/auth/auth.module').then(m => m.AuthModule) },
  {
    path: `reset-password`,
    loadChildren: () =>
      import('./views/pages/auth/reset-password/reset-password.module').then(
        (m) => m.ResetPasswordModule,
      ),
  },
  {
    path: 'notfound',
    loadChildren: () =>
      import('./views/pages/notfound/notfound.module').then(
        (m) => m.NotfoundModule,
      ),
  },
  { path: '**', redirectTo: '/notfound' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
